import queryString from 'query-string';

const ContextUrl = {};

ContextUrl.get = (qstring) => {
    qstring = qstring || window.location.search;
    const qs = queryString.parse(qstring);
    const contextUrl = qs.contextUrl || '';
    return contextUrl;
};

ContextUrl.set = (qstring, contextUrl) => {
    contextUrl = contextUrl || window.location.pathname;
    qstring = qstring || window.location.search;
    let qs = queryString.parse(qstring);
    qs.contextUrl = contextUrl;
    qs = queryString.stringify(qs);
    return qs;
};

export { ContextUrl };


// WEBPACK FOOTER //
// ./src/nams2020/common/utils/ContextUrl.js